import InfoOutlined from '@mui/icons-material/InfoOutlined';
import {Box, Tooltip, Typography} from '@mui/material';

/** 右ペイン上部の見出し: ファイルパス（折り返す）＋補足の情報アイコン、その下に1行のメタ情報 */
export default function PaneHeader({
  title,
  meta,
  note
}: {
  title: string;
  meta?: string;
  /** タイトル横の情報アイコンのツールチップに出す補足 */
  note: string;
}) {
  return (
    <Box sx={{flexShrink: 0}}>
      <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 0.5}}>
        <Typography variant="h6" sx={{overflowWrap: 'anywhere', lineHeight: 1.4}}>
          {title}
        </Typography>
        <Tooltip title={note}>
          <Box
            component="span"
            tabIndex={0}
            sx={{display: 'inline-flex', color: 'text.secondary', mt: 0.5, cursor: 'help'}}
          >
            <InfoOutlined fontSize="small" />
          </Box>
        </Tooltip>
      </Box>
      {meta && (
        <Typography variant="caption" component="p" color="text.secondary">
          {meta}
        </Typography>
      )}
    </Box>
  );
}
